(function(){
	'use strict';
	angular.module('app.setup')
	.controller('manageEmailAlerts', manageEmailAlerts);

	manageEmailAlerts.$inject = ['$scope', '$timeout',
		'leanFilterService', 'tableFilterFunctionsService', 'storeService'];

	function manageEmailAlerts($scope, $timeout,
			leanFilterService, tableFilterFunctionsService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		vm.reportTitle = 'Manage Subscriptions';
		vm.displayTab = 'users';
		vm.selectTab = function (tabName) {
			vm.displayTab = tabName;
		};

		$scope.filterFunctions = tableFilterFunctionsService;
		// Filter related functions
		$scope.filterFunctions.applySelection = function ($event) {
			tableFilterFunctionsService.applySelectionInner($event, getData, null, true, reportSettingsName, vm.getMeta().reportSettingsId);
		};
		$scope.filterFunctions.removeFilter = function (filter) {
			tableFilterFunctionsService.removeFilterInner(filter, getData, true, reportSettingsName, vm.getMeta().reportSettingsId);
		};
		$scope.filterFunctions.clearAllFilters = function () {
			tableFilterFunctionsService.clearAllFiltersInner(getData, true, reportSettingsName, vm.getMeta().reportSettingsId, defaultFilters);
		};
	
		$scope.filterService = leanFilterService;
	};
})();
